import React, { useState } from "react";
import { Alert, Box, Button, Input, Text } from "@showitinc/showit-wc";
import styles from "./ImportMainView.module.css";

import ButtonBar from "../base/ButtonBar";

const ImportMainView = ({ close, getDesign, processError }) => {
  const [exportKey, setExportKey] = useState("");

  const renderProcessError = () => (
    <Box my="2" pl="3">
      <Alert
        weight="bold"
        variant="error"
        message="Sorry, there was no design found for that key"
      />
    </Box>
  );

  return (
    <div className="panel-column" style={{ position: "relative", height: "100%" }}>
      <Box px="3" mb="1">
        <Box pb="4" d="flex" align="end">
          <span className="glyphicon glyphicon-cloud_plus" style={{ fontSize: 40, opacity: 0.5 }} />
          <Box ml="4">
            <Text variant="header-2">Add a design to your library</Text>
          </Box>
        </Box>
        <Text variant="body-2">
          Please enter the &apos;Shared Design&apos; key you were provided:
        </Text>
      </Box>
      <Box pr="3" mb="1">
        <Input
          value={exportKey}
          className={styles.sharedDesignKeyLabel}
          onSIInput={({ target }) => setExportKey(target.value)}
          label="Shared Design Key"
          placeholder="Enter Key..."
        />
      </Box>
      {processError ? renderProcessError() : null}
      <div style={{ position: "absolute", bottom: 0, width: "100%" }}>
        <ButtonBar>
          <Box mr="3">
            <Button variant="minimal" onClick={close}>
              Cancel
            </Button>
          </Box>
          <Button disabled={!exportKey} variant="feature" onClick={() => getDesign(exportKey)}>
            Add design
          </Button>
        </ButtonBar>
      </div>
    </div>
  );
};

export default ImportMainView;
